import React from 'react';
import ClassAssembly9D  from 'views/ClassAssembly9D';

const ClassAssembly9DPage = () => {
    return <ClassAssembly9D />;
  };
  
  export default ClassAssembly9DPage;

  //9D